<!--
 * @Descripttion: 修改了一些内容
 * @version: v1.0
 * @Author: htt
 * @Date: 2021-10-09 11:13:00
 * @LastEditors: htt
 * @LastEditTime: 2021-12-06 14:14:51
-->
<template>
  <div class="info appointment">
    <page-title pageName="场地维护"></page-title>
        <Space></Space>
    <div class="topBtns">
      <div class="searchKey">
        <el-input v-model="searchKey" placeholder="请输入中心名称/场地联系人"></el-input>
      </div>
      <el-button @click="getData">查询</el-button>
<!--      <el-button type="primary" @click="toRefresh">刷新</el-button>-->
      <el-button type="primary" @click="routerAdd">新增</el-button>
    </div>
    <Space></Space>
    <el-table
      v-loading="loading"
      :data="listData"
      border
      stripe
      :highlight-current-row="true"
      style="width: 100%;margin-top:16px;"
      align="center"
    >
      <el-table-column
        label="序号"
        width="50"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="tradeOrgName"
        label="交易中心"
        align="center"
      />
      <el-table-column
        prop="linkMan"
        label="场地联系人"
        align="center"
        show-overflow-tooltip
      />
      <el-table-column
        prop="linkPhone"
        label="联系方式"
        align="center"
      />
      <el-table-column
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="text" @click="openDefend(scope.row)">维护</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div>
      <pagination
          class="limit"
          :page-sizes="[7, 14, 21, 28,35]"
          :total.sync="paginationOpt.total"
          :page.sync="paginationOpt.pageIndex"
          :limit.sync="paginationOpt.pageSize"
          @pagination="getData"
      />
    </div>
  </div>
</template>
<script>
import {
  infoBaseList
} from '@/server/field'
import Pagination from "@/components/Pagination";
import Space from '@/components/space.vue'
import pageTitle from '@/components/pageTitle.vue'
export default {
  components: {
    // InfoDetail
    Pagination,
    Space,
    pageTitle
  },
  data() {
    return {
      loading: false,
      listData: [],
      searchKey:"",
      paginationOpt:{
          pageIndex:1,
          pageSize:10,
          total:0,
          pageSizes:[10,20,50]
        },
    }
  },
  activated() {
    this.listQuery = this.$options.data.call(this).listQuery
    this.getData()
  },
  methods: {
    // 获取列表数据
    getData() {
      this.loading = true
      const supperAdmin = this.$store.state.user.userinfo.supperAdmin
      infoBaseList({
        page: this.paginationOpt.pageIndex,
        rows:this.paginationOpt.pageSize,
        filter: {
          tradeOrgId: supperAdmin ? '' : this.$store.state.user.userinfo.orgInfo.orgId
        }
      }).then(res => {
        this.loading = false
        if (res.data.code) {
          this.$message.error(res.data.msg)
          return
        }
        const { data } = res
        this.listData = data.rows || []
        this.paginationOpt.total = data.total || 0;
      })
    },
    sizeChangeHandle(value){// 每页长度改变待办事项
      this.paginationOpt.pageSize=value;
      this.paginationOpt.pageIndex=1;
      this.getData();
    },
    pageChangeHandle(value){ // 当前页改变待办事项
      this.paginationOpt.pageIndex = value;
      this.getData();
    },
    openDefend(row) {
      this.removeTabHandle('fieldmg-config')
      this.$router.push({
        path: '/fmanage/config'
      })
      sessionStorage.setItem('row', JSON.stringify(row))
    },
    routerAdd(){
      this.removeTabHandle('fieldmg-config')
      sessionStorage.removeItem('row')
      this.$router.push({
        path: '/fmanage/config'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.appointment{
    padding: 0 16px 16px;

  .topBtns{
    display: flex;
    margin:16px 0;
    .searchKey{
      width: 200px;
    }
    .el-button--medium{
      height: 36px;
      margin: 0 0 0 10px;
    }
  }
}
</style>
